import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Link, NavLink } from 'react-router-dom';
import Home from '../../pages/Home/Home';
import Sobre from '../../pages/Sobre/Sobre';
import Servicos from '../../pages/Servicos/Servicos';
import Contato from '../../pages/Contato/Contato';
import ParticipacaoRemunerada from '../../pages/ParticipacaoRemunerada/ParticipacaoRemunerada';
import CalculadoraV2 from '../../pages/CalculadoraV2/CalculadoraV2';
import CalculadoraV1 from '../../pages/CalculadoraV1/CalculadoraV1';
import './Navbar.css';
import '../../styles.css'
import { ToastContainer } from 'react-toastify';
import Blog from "../../pages/Blog/Blog";
import News1 from "../../pages/News1/News1";
import News2 from "../../pages/News2/News2";
import News3 from "../../pages/News3/News3";
import News4 from "../../pages/News4/News4";
import News5 from "../../pages/News5/News5";
import News6 from "../../pages/News6/News6";
import News7 from "../../pages/News7/News7";
import PoliticaPrivacidade from "../../pages/PoliticaPrivacidade/PoliticaPrivacidade";


function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') setMenuOpen(false);
    };
    const desktopQuery = window.matchMedia('(min-width: 801px)');
    const handleResize = () => {
      if (desktopQuery.matches) setMenuOpen(false);
    };
    window.addEventListener('keydown', handleKeyDown);
    desktopQuery.addEventListener('change', handleResize);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      desktopQuery.removeEventListener('change', handleResize);
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const linkClass = ({ isActive }) =>
    isActive
      ? 'underline underline-offset-4 decoration-2 font-bold'
      : 'text-white hover:text-gray-200 transition-colors duration-200';

  const linkStyle = ({ isActive }) => isActive ? { color: '#f5be88' } : {};

  return (
    <Router>
      <nav
        className={`fixed top-0 left-0 w-full px-8 h-sm:px-4 py-2 text-base z-50 transition-all duration-300 ${scrolled ? 'shadow-xl' : 'shadow-md'}`}
        style={{
          backgroundColor: scrolled || menuOpen ? 'rgba(0, 46, 77, 0.98)' : 'rgba(0, 46, 77, 0.82)',
          backdropFilter: 'blur(14px)',
          WebkitBackdropFilter: 'blur(14px)',
        }}
      >

        <ToastContainer position="top-right" className="z-[9999]" />
        <div className="flex items-center h-sm:h-20 h-sm:justify-between">
          <div className="w-2/12 h-sm:w-auto flex justify-center items-center">
            <Link to="/" onClick={() => setMenuOpen(false)}>
              <img className="h-16 h-sm:h-10" src="logo-objetiva2.png" alt='logo' style={{ filter: 'brightness(0) invert(1)' }} />
            </Link>
          </div>
          <div className="w-8/12 h-sm:hidden">
            <ul className="flex justify-center items-center list-none h-20 font-raleway">
              <li className="w-1/12 text-center font-semibold">
                <NavLink to="/" className={linkClass} style={linkStyle}>Home</NavLink>
              </li>
              <li className="w-2/12 text-center font-semibold">
                <NavLink to="/sobre" className={linkClass} style={linkStyle}>Quem somos</NavLink>
              </li>
              <li className="w-3/12 text-center font-semibold">
                <NavLink to="/participacaoRemunerada" className={linkClass} style={linkStyle}>Programa de parceria remunerada</NavLink>
              </li>
              <li className="w-3/12 text-center font-semibold">
                <NavLink to="/servicos" className={linkClass} style={linkStyle}>Intermediação de cotas canceladas</NavLink>
              </li>
              <li className="w-2/12 text-center font-semibold">
                <NavLink to="/contato" className={linkClass} style={linkStyle}>Contato</NavLink>
              </li>
              <li className="w-1/12 text-center font-semibold">
                <NavLink to="https://objetivascp.com.br/login" target="_blank" className={linkClass} style={linkStyle}> SCP</NavLink>
              </li>
            </ul>
          </div>
          <button
            type="button"
            className="hidden h-sm:flex items-center justify-center w-11 h-11 rounded-lg border border-white/40 text-white hover:bg-white/10 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
            aria-label={menuOpen ? 'Fechar menu' : 'Abrir menu'}
            aria-expanded={menuOpen}
            aria-controls="mobile-navigation"
            onClick={() => setMenuOpen((open) => !open)}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
              {menuOpen ? <path d="M6 6l12 12M6 18L18 6" /> : <path d="M3 6h18M3 12h18M3 18h18" />}
            </svg>
          </button>
        </div>
        <div id="mobile-navigation" className={menuOpen ? 'hidden h-sm:block border-t border-white/20 max-h-[calc(100dvh-96px)] overflow-y-auto' : 'hidden'}>
          <ul className="flex flex-col list-none py-3 font-raleway text-white">
            {[
              ['/', 'Home'],
              ['/sobre', 'Quem somos'],
              ['/participacaoRemunerada', 'Programa de parceria remunerada'],
              ['/servicos', 'Intermediação de cotas canceladas'],
              ['/contato', 'Contato'],
            ].map(([to, label]) => (
              <li key={to}>
                <NavLink to={to} className={(state) => `block px-3 py-3 rounded-lg hover:bg-white/10 ${linkClass(state)}`} style={linkStyle} onClick={() => setMenuOpen(false)}>{label}</NavLink>
              </li>
            ))}
            <li>
              <a href="https://objetivascp.com.br/login" target="_blank" rel="noreferrer" className="block px-3 py-3 rounded-lg hover:bg-white/10" onClick={() => setMenuOpen(false)}>SCP</a>
            </li>
          </ul>
        </div>
      </nav>
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route path="/participacaoRemunerada" element={<ParticipacaoRemunerada />} />
        <Route path="/sobre" element={<Sobre />} />
        <Route path="/servicos" element={<Servicos />} />
        <Route path="/contato" element={<Contato />} />
        <Route path="/calculadoraV2" element={<CalculadoraV2 />} />
        <Route path="/calculadoraV1" element={<CalculadoraV1 />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/news1" element={<News1 />} />
        <Route path="/news2" element={<News2 />} />
        <Route path="/news3" element={<News3 />} />
        <Route path="/news4" element={<News4 />} />
        <Route path="/news5" element={<News5 />} />
        <Route path="/news6" element={<News6 />} />
        <Route path="/news7" element={<News7 />} />
        <Route path="/politica-privacidade" element={<PoliticaPrivacidade />} />
      </Routes>
    </Router>
  );
}

export default Navbar;
